import { CustomPDFReportDesignation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-designation.enum';
export const REPORT_TYPE_LEGACY_TEARSHEETS = 'legacy_tearsheets';
export const REPORT_TYPE_LEGACY_Y_RATING = 'legacy_y_rating';
export const DELETE_HIDDEN_REPORT_TYPES = [REPORT_TYPE_LEGACY_TEARSHEETS, REPORT_TYPE_LEGACY_Y_RATING];
export const NAMING_CONVENTION_PREFERENCE_KEY = 'customPDFReports_namingConvention';
export const DESIGNATION_TYPE_NAME_MAPPING = {
    [CustomPDFReportDesignation.DRAFT]: 'Draft',
    [CustomPDFReportDesignation.DELIVERABLE]: 'Deliverable',
};
// Validator parameters
export const REPORT_CONTACT_EMAIL_MAX_LENGTH = 255;
export const REPORT_CONTACT_PHONE_MAX_LENGTH = 20;
export const REPORT_CONTACT_URL_MAX_LENGTH = 150;
export const REPORT_PREPARED_FOR_MAX_LENGTH = 50;
export const REPORT_ORGANIZATION_MAX_LENGTH = 50;
export const REPORT_TITLE_MAX_LENGTH = 150;
export const MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MAX = 5;
export const MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MIN = 2;
